import {keyframes} from "@emotion/react";

export const cardStyles = palette => ({
	height: 1,
	minHeight: 260,
	"&:has(.is-loading)": {
		animation: `${keyframes({
			"0%": { backgroundColor: palette.primary.light },
			"100%": { backgroundColor: palette.primary.lighter }
		})} 1s linear infinite alternate`,
		opacity: .5,
		border: `1px solid ${palette.primary.light}`
	},
	"&.is-filtered": {
		border: `1px solid ${palette.primary.dark}`,
		backgroundColor: palette.primary.lighter
	}
})